// extracted by mini-css-extract-plugin
export var addressFields = "_np-0";
export var animationContainer = "_np-1";
export var footer = "_np-2";
export var lineItems = "_np-3";
export var modalContent = "_np-4";
export var orderName = "_np-5";
export var strong = "_np-6";
export var warning = "_np-7";